import { HelpDrawerAnalytics } from "./HelpDrawerWrapper";
import { Dispatch } from "react";
import {
  AnalyticsActions,
  AnalyticsActionType,
  Ga4Event,
  Ga4EventDimensions,
  TealiumEventProps,
} from "../app/contexts/Analytics/types";

export const newBasicHelperDrawerAnalytics = ({
  clickText = "",
  dispatch,
  customGA4OpenSettings,
  customGA4CloseSettings,
  customTealiumOpenSettings,
  customTealiumCloseSettings,
}: {
  clickText?: string;
  dispatch: Dispatch<AnalyticsActions>;
  customGA4OpenSettings?: Ga4EventDimensions;
  customGA4CloseSettings?: Ga4EventDimensions;
  customTealiumOpenSettings?: TealiumEventProps;
  customTealiumCloseSettings?: TealiumEventProps;
}): HelpDrawerAnalytics => {
  return {
    openDrawer: () => {
      dispatch({
        type: AnalyticsActionType.SEND_TEALIUM_EVENT,
        settings: {
          event_action: "Help drawer",
          event_label: "opened",
          ...customTealiumOpenSettings,
        },
      });
      dispatch({
        type: AnalyticsActionType.SEND_GA4_EVENT,
        settings: {
          click_text: clickText,
          event_name: Ga4Event.HELP_DRAWER_OPENED,
          ...customGA4OpenSettings,
        },
      });
    },
    closeDrawer: () => {
      dispatch({
        type: AnalyticsActionType.SEND_TEALIUM_EVENT,
        settings: {
          event_action: "Help drawer",
          event_label: "closed",
          ...customTealiumCloseSettings,
        },
      });
      dispatch({
        type: AnalyticsActionType.SEND_GA4_EVENT,
        settings: {
          event_name: Ga4Event.HELP_DRAWER_CLOSED,
          click_text: clickText,
          ...customGA4CloseSettings,
        },
      });
    },
  };
};
